<template>
<div>
    <el-dialog :title="title" class="c-dialog-fixed" width="700px" :visible.sync="show" :append-to-body="inDialog" :modal="false" :close-on-click-modal="false" :close-on-press-escape="false" center top="5vh" @open="openDialog" @close="closeDialog">
        <el-form ref="form" :model="form" :rules="rules" label-width="110px" size="mini" status-icon class="c-form-mini">
            <el-row>
                <el-col :span="12">
                    <el-form-item label="国家/地区:" prop="country">
                        <el-select v-model="form.area" placeholder="请选择" class="filter-item" style="width: 200px;" filterable clearable allow-create default-first-option>
                            <el-option v-for="item in countrylist" :key="item.id" :label="item.title" :value="item.title" />
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="类型:" prop="type">
                        <el-select v-model="form.type" placeholder="请选择" class="filter-item" style="width: 200px;" filterable clearable allow-create default-first-option>
                            <el-option v-for="item in typelist" :key="item.value" :label="item.label" :value="item.value" />
                        </el-select>
                        <!-- <el-input v-model="form.type" style="width: 200px;" placeholder="请输入类型..."></el-input> -->
                    </el-form-item>
                </el-col>
            </el-row>

            <el-row>
                <el-col :span="12">
                    <el-form-item label="邮件名称:" prop="name">
                        <el-input v-model="form.name" type="primary" style="width: 200px" placeholder="请输入" />
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="发送时间:" prop="name">
                        <el-date-picker v-model="form.sendAt" style="width: 200px" type="datetime" placeholder="选择日期时间" default-time="12:00:00">
                        </el-date-picker>
                    </el-form-item>
                </el-col>
            </el-row>

            <el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="审核状态:" prop="status">
                            <el-select v-model="form.status" placeholder="选择审核状态" class="filter-item" style="width: 200px;" filterable disabled allow-create clearable>
                                <el-option v-for="item in statuslist" :key="item.value" :label="item.label" :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-col :span="12">
                    <el-form-item label="邮件内容:" prop="content">
                        <textarea v-model="form.content" style="width: 400px;height: 200px" placeholder="请输入内容..."></textarea>
                    </el-form-item>
                </el-col>

            </el-row>
            <!-- <el-row>
                        <el-col :span="12">
                    <el-form-item label="邮件附加图片:" prop="file">
                        <input type="file" />
                    </el-form-item>
                </el-col>
            </el-row> -->
        </el-form>
        <div style="text-align: center;">
            <el-upload class="upload-demo" ref="upload" :before-upload="beforeUploadFile" :show-file-list="true" :action=FILE_ACTION :on-success="handleFileSuccess" :on-preview="handlePreview" :on-remove="handleRemove" :name=this.file.name accept="png/*" :multiple="false">
                <p size="small" type="primary">点击上传</p>
            </el-upload>
            <p style="font-size: 15px;color: #888888;">文件大小不超过20MB</p>

        </div>
        <div slot="footer" class="dialog-footer">
            <el-button @click="closeDialog">
                取消
            </el-button>
            <el-button type="primary" @click="title === '添加记录' ? addData() : editData()">
                确认
            </el-button>
        </div>
    </el-dialog>

</div>
</template>

<script>
// import waves from '@/directive/waves'
import {
    template_add,
    country_list_all,
    template_edit
} from '../../api';
import {
    dealResult
} from "../../api/common";

const formInit = {
    name: '', //模板名称
    content: '', //模板内容
    status: '', //审核状态
    imgName: '', //图片名称
    imgPath: '' //图片路径
}
export default {
    name: 'AddTemplate',
    // directives: { waves },
    components: {

    },
    props: {
        module: {
            type: String,
            default: ''
        },
        inDialog: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            title: '新增',
            loading: false,
            form: {
                ...formInit
            },
            file: null,
            FILE_ACTION: '',
            countrylist: [],

            typelist: [{
                    value: '佛',
                    label: '佛'
                },
                {
                    value: '基督',
                    label: '基督'
                },
                {
                    value: '无宗教',
                    label: '无宗教'
                }
            ],

            statuslist: [{
                    value: '是',
                    label: '是'
                },
                {
                    value: '否',
                    label: '否'
                }
            ],
            show: false,
            updated: false,
            nowUser: '',
            lander: {},
            file: {},
            query: {},
            rules: {
                itemcode: [{
                    required: true,
                    pattern: /^\d{13}$/,
                    message: '请输入13位纯数字物料编码',
                    trigger: ''
                }],

            }
        }
    },
    created() {

    },
    mounted() {
        this.nowUser = localStorage.getItem('account')
        this.lander = JSON.parse(this.$store.state.logininfo);
        this.FILE_ACTION = process.env.VUE_APP_API_ROOT + '/email-templates/uploadImg?uid=' + this.lander.uid + "&token=" + this.lander.token;
        this.getCountry();

    },
    methods: {
        openDialog() {
            this.$nextTick(() => {
                if (this.resolve) {
                    this.resolve(this)
                }
            })
        },
        //获取国家清单数据
        getCountry() {
            this.query.uid = this.lander.uid;
            this.query.token = this.lander.token;
            country_list_all(this.query).then((res) => {
                if (res.data.status == 1) {
                    this.countrylist = res.data.obj
                } else {
                    this.$message.error(res.data.msg)
                }
            })
        },
        open() {
            this.show = true
            return new Promise((resolve, reject) => {
                this.resolve = resolve
            })
        },
        clearValidate() {
            this.$nextTick(() => {
                this.$refs.form && this.$refs.form.clearValidate()
            })
        },
        resetFields() {
            this.updated = false
            this.form = {
                ...formInit
            }
            this.clearValidate()
            return this
        },
        closeDialog() {
            const vm = this
            vm.form = {
                ...formInit
            }
            this.file = {}
            this.show = false
            this.clearUpload()
            this.resetFields()
        }, // 关闭弹窗操作
        update() {
            this.loading = false
            this.updated = true
            this.show = false
            this.$emit('addRefresh')
            this.resetFields()
        },

        updateForEdit() {
            this.$parent.$emit('addRefresh')
            this.loading = false
            this.updated = true
            this.show = false
            this.resetFields()
        },
        initData(data, title) {
            if (title == 'add') {
                this.title = "添加记录"
            } else {
                this.title = "编辑数据"
            }
            this.assign(data)
            this.clearValidate()
        },
        assign(data) {
            this.form = {
                ...this.form,
                ...data
            }
            return this
        },
        handleRemove(file, fileList) {

        },

        // 清空上传列表
        clearUpload() {
            this.$refs.upload.clearFiles(); // 调用 el-upload 的 clearFiles 方法
        },
        
        handleFileSuccess(res) {
            this.loading.close();
            dealResult(res);
            if (res.status == 1) {
                this.form.imgName = res.msg;
                this.$message.success('文件已成功上传至服务器，请执行后续添加操作');
            } else {
                this.$message.error(res.msg);
            }

        },
        beforeUploadFile(file) {
            const isLt2M = file.size / 1024 / 1024 < 20;
            if (file.name.includes('.')) {
                this.decimalPart = file.name.split('.')[1]; // 分割字符串并获取小数点后的部分
                console.log(this.decimalPart);
                if (this.decimalPart !== 'jpg' && this.decimalPart !== 'png' && this.decimalPart !== 'gif' && this.decimalPart !== 'webp' && this.decimalPart !== 'bmp') {
                    return this.$message.error('请上传后缀为jpg、png、gif、webp、bmp的类型图片文件!');
                }
            }
            if (!isLt2M) {
                this.$message.error('上传的图片大小不能超过 20MB!');
                return isLt2M;
            }

            this.loading = this.$loading({
                lock: true,
                text: "上传中，请稍等,,,,",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.5)",
            });
        },

        handlePreview(file) {
        },

        addData() {
            this.$refs['form'].validate(() => {
                this.form.uid = this.lander.uid;
                this.form.token = this.lander.token;
                console.log(this.form);
                template_add(this.form).then((res) => {
                    dealResult(res.data);
                    if (res.data.status == 1) {
                        this.$message.success(res.data.msg);
                        this.update()
                    } else {
                        this.$message.error(res.data.msg)
                    }
                })

            })
        },
        editData() {

            this.$refs['form'].validate((valid) => {
                if (valid) {
                    this.form.uid = this.lander.uid;
                    this.form.token = this.lander.token;

                    template_edit(this.form).then((res) => {
                        dealResult(res.data);
                        if (res.data.status == 1) {
                            this.$message.success(res.data.msg);
                            this.update()
                        } else {
                            this.$message.error(res.data.msg)
                        }

                    })
                }
            })
        },

    }
}
</script>

<style lang="scss" scoped>
</style>
